import React, { ReactNode } from 'react';

import { LAUNCHPAD_SALE_POOL_TYPE, LaunchpadSalePoolType } from '@api';

import BaseInfoTooltip from '@shared/common/components/BaseInfoTooltip';
import { LAUNCHPAD_TOKEN_INFO } from '@shared/constants';

import { getFeeTooltipMessage } from './getFeeTooltipMessage';

type Props = {
  feeCalculatedValue?: number;
  amount: string | number;
  currency?: string;
  children?: ReactNode;
  className?: string;
  poolType?: LaunchpadSalePoolType;
  isSqrpBasedOffchainPool?: boolean;
};

export const DepositFeeTooltip = ({
  feeCalculatedValue,
  amount,
  currency,
  children,
  className,
  poolType = LAUNCHPAD_SALE_POOL_TYPE.PRO_RATA,
  isSqrpBasedOffchainPool,
}: Props) => {
  if ((!isSqrpBasedOffchainPool && !feeCalculatedValue) || Number(amount) <= 0) {
    return null;
  }

  return (
    <BaseInfoTooltip
      className={className ? className : 'ml-1'}
      content={
        <div>
          <div>
            {getFeeTooltipMessage(
              feeCalculatedValue || 0,
              amount,
              currency || LAUNCHPAD_TOKEN_INFO.symbol,
              poolType,
            )}
          </div>
          {children ? children : null}
        </div>
      }
    />
  );
};
